(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initProfessionalFeatures = (scope = document) => {
    const sections = scope.matches?.('[data-k9-professional]')
      ? [scope]
      : [...scope.querySelectorAll('[data-k9-professional]')];

    sections.forEach((section) => {
      if (section.dataset.k9WaveformReady) return;
      section.dataset.k9WaveformReady = 'true';
      const waveformFeature = section.querySelector('.k9-professional__feature--waveform');

      if (!waveformFeature) return;

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        section.classList.add('is-waveform-drawn');
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          section.classList.add('is-waveform-drawn');
          observer.unobserve(waveformFeature);
          observer.disconnect();
        },
        { threshold: 0.65, rootMargin: '0px 0px -10% 0px' }
      );

      observer.observe(waveformFeature);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProfessionalFeatures(), { once: true });
  } else {
    initProfessionalFeatures();
  }

  document.addEventListener('shopify:section:load', (event) => initProfessionalFeatures(event.target));
})();
